import { useQuery } from '@tanstack/react-query';
import { getTenant, type TenantDto } from './api';

export const TENANT_KEY = ['tenant'] as const;

/** The current tenant, cached. Drives the shell greeting and tenant settings. */
export function useTenant() {
  return useQuery<TenantDto>({
    queryKey: TENANT_KEY,
    queryFn: ({ signal }) => getTenant(signal),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
